<template>
  <div id="app">
    <Top />
    <router-view />
    <Bottom />
  </div>
</template>
<script>
import Top from "@/components/top";
import Bottom from "@/components/bottom";

export default {
  components: {
    Top,
    Bottom,
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  background: linear-gradient(to right, #140223, #121f45);
  // width: 100vw;
  // height: 100vh;
  margin: 0 auto;
  // width: 100%;
  overflow: hidden;
}
</style>
